// extracted by mini-css-extract-plugin
export default {"container":"VariablesTags_container__bwjYG","flex_center":"VariablesTags_flex_center__e7JwW","dropDown":"VariablesTags_dropDown__8Zkyd","spin":"VariablesTags_spin__1WcXW"};